import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';

import { ArkUnitOfWork } from 'app/core/core.module';
import { EntityQuery, Predicate } from 'breeze-client';
import { SharedModule } from 'app/shared/shared.module';
import { DevExtremeModule, DxDataGridComponent } from 'devextreme-angular';
import { BsModalService } from 'ngx-bootstrap/modal';
import { confirm, alert } from 'devextreme/ui/dialog';
import _ from 'lodash';

@Component({
    selector: 'app-list',
    templateUrl: './list.component.html',
    styleUrls: ['./list.component.scss'],
    providers: [ArkUnitOfWork],
    imports: [DevExtremeModule]
})
export class ListComponent implements OnInit {
    interests: any;
    categories: any;
    selectedCategory: any;
    selectedInterest: any;
    dialogInterest: any;

    onToolbarPreparing = SharedModule.onToolbarPreparing;
    @ViewChild('categoryGrid') categoryGrid: DxDataGridComponent;

    constructor(private uow: ArkUnitOfWork, private modalService: BsModalService) {}

    async ngOnInit() {
        this.getCategories();
    }

    async getCategories() {
        this.uow.clearCached('InterestCategory');
        this.uow.clearCached('Interest');
        this.categories = await this.uow.interests.getCategories();
    }

    // async getSelectedRow(grid: DxDataGridComponent) {
    //     if (!grid.instance) return null;
    //     const selectedRow = await grid.instance.byKey(this.categoryGrid.focusedRowKey);
    //     return selectedRow;
    // }

    async categoryRowChanged(e) {
        this.selectedCategory = e.row.data; // await this.categoryGrid.instance.byKey(this.categoryGrid.focusedRowKey);
        // this.interests = _(this.selectedCategory.interests)
        //     .filter({ deleted: null })
        //     .value();
    }

    interestRowChanged(e) {
        this.selectedInterest = e.row && e.row.data;
    }

    async editCategory(template: TemplateRef<any>, grid?: DxDataGridComponent) {
        if (!grid) this.selectedCategory = this.uow.manager.createEntity('InterestCategory');
        this.editDialog(template);
    }

    async deleteCategory(grid: DxDataGridComponent) {
        if (await confirm(`Are you sure you want to delete the "${this.selectedCategory.name}" category?`, 'Delete Category')) {
            // this.selectedCategory.entityAspect.setDeleted();
            this.selectedCategory.deleted = new Date();
            await this.uow.commit();
            await this.getCategories();
            grid.instance.refresh();
        }
    }

    async editInterest(template: TemplateRef<any>, grid?: DxDataGridComponent) {
        this.dialogInterest = !grid
            ? this.uow.manager.createEntity('Interest', { interestCategoryId: this.selectedCategory.id })
            : await grid.instance.byKey(grid.focusedRowKey);
        this.editDialog(template);
    }

    async deleteInterest(grid: DxDataGridComponent) {
        if (await confirm(`Are you sure you want to delete the "${this.selectedInterest.name}" interest?`, 'Delete Interest')) {
            // this.selectedInterest.entityAspect.setDeleted();
            this.selectedInterest.deleted = new Date();
            await this.uow.commit();
            await this.getCategories();
            grid.instance.refresh();
        }
    }

    async editDialog(template: TemplateRef<any>) {
        const modalRef = this.modalService.show(template, { backdrop: 'static', class: 'modal-sm' });
        this.modalService.onHidden.subscribe(reason => {
            this.closeDialog();
        });
    }

    async saveDialog(grid: DxDataGridComponent) {
        await this.uow.commit();
        this.getCategories();
        grid.instance.refresh();
        this.closeDialog();
    }

    closeDialog() {
        this.uow.rollback();
        this.modalService.hide(1);
    }
}
